<template>
  <div id="invalid-page">
    <div class="content">
      <div class="ipub-h2 mar-b-20">
        <div class="mar-b-20">
          <ipub-icon type="iconDetails"
                     class="key-color"
                     style="font-size:52px"></ipub-icon>
        </div>
        {{type==='review'?'Request Canceled':'Not Available'}}
      </div>
      <div class="ipub-p2 font-color"
           style="width:416px;font-size:16px"
           v-if="type==='review'">
        Your review request was canceled as we did not hear from you in due course, in case of any questions please feel free to contact us at
        <span>
          <a class="ipub-p2 link-color"
             :href="`mailto:${detail.journal && detail.journal.contactEmail}`">{{detail.journal && detail.journal.contactEmail}}</a>.
        </span>
      </div>
      <div class="ipub-p2 font-color"
           style="width:416px;font-size:16px"
           v-else>
        This action link is not currently available. Please do not hesitate to contact us if you need any help from us, or any further information about us
        <div class="ipub-p2 link-color">
          <font>
            < {{decisionType ? (detail.manuscript && detail.manuscript.journal && detail.manuscript.journal.contactEmail):(detail.journal && detail.journal.contactEmail)}}>.
          </font>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
#invalid-page {
  height: calc(100vh - 300px);
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    background: $content_color;
    // width: 583px;
    // height: 424px;
    border-radius: 4px;
    text-align: center;
    padding: 100px 80px;
  }
}
</style>